export enum HEADER_TYPES {
	Dark = 'dark',
	Light = 'light',
}
